import { Fragment, useEffect, useRef, useState } from "react"
import { Col, Row, Form, Card, Button } from 'react-bootstrap';
import { BabyGruMapSelect } from './BabyGruMapSelect'
import { BabyGruMoleculeSelect } from './BabyGruMoleculeSelect'
import BabyGruSlider from './BabyGruSlider' 

export const BabyGruPepflipsDifferenceMap = (props) => {
    const mapSelectRef = useRef();
    const moleculeSelectRef = useRef();
    const [pepflips, setPepflips] = useState(null)
    const [selectedModel, setSelectedModel] = useState(null)
    const [selectedMap, setSelectedMap] = useState(null)
    const [cachedAtoms, setCachedAtoms] = useState(null)
    const [selectedRmsd, setSelectedRmsd] = useState(4.5)
    const [cardList, setCardList] = useState([])
    
    const getDifferenceMaps = () => {
        let differenceMaps = []
        
        if (props.maps) {
            props.maps.forEach(map => {
                if(map.isDifference){
                    differenceMaps.push(map)
                }
            })
        }

        return differenceMaps

    }

    const handleModelChange = (evt) => {
        console.log(`Selected model ${evt.target.value}`)
        setSelectedModel(evt.target.value)
    }

    const handleMapChange = (evt) => {
        console.log(`Selected map ${evt.target.value}`)
        setSelectedMap(evt.target.value)
    }

    const handleFlip = (...args) => {
        const flipPeptide = async (selectedMolNo, chainId, insCode, seqNum) => {
            await props.commandCentre.current.cootCommand({
                returnType: "status",
                command: "flipPeptide_cid",
                commandArgs: [selectedMolNo, `/${insCode}/${chainId}/${seqNum}/C`, ''],
                changesMolecules: [selectedMolNo]
            }, true)

            if (props.refineAfterMod) {
                console.log('Triggering post-modification triple refinement...')
                await props.commandCentre.current.cootCommand({
                    returnType: "status",
                    command: 'refine_residues_using_atom_cid',
                    commandArgs: [selectedMolNo, `/${insCode}/${chainId}/${seqNum}`, 'TRIPLE'],
                    changesMolecules: [selectedMolNo]
                }, true)    
            }

            const selectedMolecule = props.molecules.find(molecule => molecule.molNo == selectedModel)
            selectedMolecule.setAtomsDirty(true)
            selectedMolecule.redraw(props.glRef)
            //Here use originChanged event to force recontour (relevant for live updating maps)
            const originChangedEvent = new CustomEvent("originChanged",
                { "detail": props.glRef.current.origin });
            document.dispatchEvent(originChangedEvent);
        }

        if (args.every(arg => arg !== null)) {
            flipPeptide(...args)
        }

    }

    useEffect(() => {
        if (props.molecules.length === 0) {
            setSelectedModel(null)
        } else if (selectedModel === null) {
            setSelectedModel(props.molecules[0].molNo)
        } else if (!props.molecules.map(molecule => molecule.molNo).includes(selectedModel)) {
            setSelectedModel(props.molecules[0].molNo)
        }

    }, [props.molecules.length])

    useEffect(() => {
        const differenceMaps = getDifferenceMaps()

        if (props.maps.length === 0 || differenceMaps.length === 0) {
            setSelectedMap(null)
        } else if (selectedMap === null) {
            setSelectedMap(differenceMaps[0].molNo)
        } else if (!differenceMaps.map(map => map.molNo).includes(selectedMap)) {
            setSelectedMap(differenceMaps[0].molNo)
        }

    }, [props.maps.length])
   
    useEffect(() => {
        if (selectedModel !== null) {
            let selectedMoleculeIndex = props.molecules.findIndex(molecule => molecule.molNo == selectedModel);
            if (selectedMoleculeIndex != -1 && props.molecules[selectedMoleculeIndex]){
                setCachedAtoms(props.molecules[selectedMoleculeIndex].cachedAtoms)
            }
        }
    })
    
    useEffect(() => {
        async function fetchData(inputData) {
            let response = await props.commandCentre.current.cootCommand(inputData)
            let newPepflips = response.data.result.result
            setPepflips(newPepflips)
        }

        if (selectedModel === null || selectedMap === null || selectedRmsd === null) {
            setPepflips(null)
            return
        }
        
        const inputData = {
            message:'coot_command',
            command: "pepflips_using_difference_map", 
            returnType:'interesting_places_data',
            commandArgs:[selectedModel, selectedMap, selectedRmsd]
        }
    
        fetchData(inputData)   

    }, [selectedMap, selectedModel, cachedAtoms, selectedRmsd])

    useEffect(() => {

        if (selectedMap === null || selectedModel === null || selectedRmsd === null || !props.toolAccordionBodyHeight || !props.showSideBar) {
            return;
        }

        let newCardList = []

        pepflips.forEach(flip => {
            newCardList.push(
                <Card style={{margin: '0.5rem'}}>
                    <Card.Body>
                        <Row style={{display:'flex', justifyContent:'between'}}>
                            <Col style={{alignItems:'center', justifyContent:'left', display:'flex'}}>
                                {flip.buttonLabel}
                            </Col>
                            <Col className='col-3' style={{margin: '0', padding:'0', justifyContent: 'right', display:'flex'}}>
                            <Button style={{marginRight:'0.5rem'}} onClick={() => {
                                            handleFlip(selectedModel, flip.chainId, flip.insCode,  flip.seqNum)
                                }}>
                                    Flip
                                </Button>
                                <Button onClick={() => {
                                            props.glRef.current.setOrigin([-flip.coordX, -flip.coordY, -flip.coordZ])
                                }}>
                                    View
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )
        })

        setCardList(newCardList)
        
    }, [pepflips, props.darkMode, props.toolAccordionBodyHeight, props.sideBarWidth, props.showSideBar])

    return <Fragment>
                <Form style={{ padding:'0', margin: '0' }}>
                    <Form.Group>
                        <Row style={{ padding:'0', margin: '0' }}>
                            <Col>
                                <BabyGruMoleculeSelect width="" onChange={handleModelChange} molecules={props.molecules} ref={moleculeSelectRef}/>
                            </Col>
                            <Col>
                                <BabyGruMapSelect filterFunction={(map) => map.isDifference} width="" onChange={handleMapChange} maps={props.maps} ref={mapSelectRef}/>
                            </Col>
                            <Col style={{justifyContent:'center', alignContent:'center', alignItems:'center', display:'flex'}}>
                                <Form.Group controlId="rmsdSlider" style={{margin:'0.5rem', width: '100%'}}>
                                    <BabyGruSlider minVal={2.5} maxVal={7.0} logScale={false} sliderTitle="RMSD" intialValue={4.5} externalValue={selectedRmsd} setExternalValue={setSelectedRmsd}/>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form.Group>
                </Form>
                <div style={{overflowY:'scroll', height:'100%', paddingTop:'0.5rem'}} >
                    {cardList}
                </div>
            </Fragment>

}
